export const SEARCH_TEST_ID = {
    PAGE_TAB_BUTTON: 'search-page-tab-button',
    NAVBAR_SEARCH: 'search',
    NAVBAR_SEARCH_WIDGET: 'navbar-search-widget',
    NAVBAR_SEARCH_INPUT_OPEN_BUTTON: 'navbar-search-input-open-button',
    NAVBAR_SEARCH_INPUT_INPUT: 'navbar-search-input-input',
    NAVBAR_SEARCH_INPUT_SEARCH_BUTTON: 'navbar-search-input-search-button',
    NAVBAR_SEARCH_INPUT_CLEAR_BUTTON: 'navbar-search-input-clear-button',
    NAVBAR_SEARCH_MOBILE_INPUT_CLOSE_BUTTON: 'navbar-search-mobile-input-close-button',
    NAVBAR_SEARCH_DESKTOP_INPUT_CLOSE_BUTTON: 'navbar-search-desktop-input-close-button',
    SEARCH_INPUT_INPUT: 'search-input-input',
    SEARCH_INPUT_CLEAR_BUTTON: 'search-input-clear-button',
    SEARCH_INPUT_SEARCH_BUTTON: 'search-input-search-button',
    SEARCH_INPUT_CLOSE_BUTTON: 'search-input-close-button',
    SEARCH_INPUT_LOADER: 'search-input-loader',
    SUGGESTIONS_DROPDOWN_CONTENT: 'search-suggestions-dropdown-content',
    SUGGESTIONS_NO_RESULTS: 'search-suggestions-no-results',
    SUGGESTIONS_POPULAR_QUERIES: 'search-suggestions-popular-queries',
    SUGGESTIONS_AUTOCOMPLETE: 'search-suggestions-auto-complete',
    SUGGESTIONS_PRODUCTS: 'search-suggestions-products',
    SUGGESTIONS_SERVICES: 'search-suggestions-services',
    SUGGESTIONS_HELP: 'search-suggestions-help',
    SUGGESTIONS_CONTENT: 'search-suggestions-content',
    SUGGESTIONS_SPECIAL_OFFERS: 'search-suggestions-special-offers',
    SUGGESTIONS_SKELETON: 'suggestions-skeleton',
    RESULTS_SPECIAL_OFFERS: 'search-results-special-offers',
    RESULTS_SPECIAL_OFFERS_PRODUCTS: 'search-results-special-offers-products',
    RESULTS_SPECIAL_OFFERS_SERVICES: 'search-results-special-offers-services',
    RESULTS_MAIN_SKELETON: 'search-results-main-skeleton',
    RESULTS_MAIN: 'search-results-main',
    RESULTS_MAIN_PRODUCTS: 'search-results-main-products',
    RESULTS_MAIN_SERVICES: 'search-results-main-services',
    RESULTS_MAIN_HELP: 'search-results-main-help',
    RESULTS_MAIN_CONTENT: 'search-results-main-content',
    RESULTS_MAIN_MORE_RESULTS: 'search-results-more-results',
    RESULTS_SECTION_TITLE: 'search-results-section-title',
    RESULTS_COUNT: 'search-results-count',
    RESULTS_PRODUCTS: 'search-results-products',
    RESULTS_PRODUCTS_SKELETON: 'search-results-products-skeleton',
    RESULTS_PRODUCTS_ITEMS: 'search-results-products-items',
    RESULTS_PRODUCTS_FACETS_PANEL: 'search-results-products-facets-panel',
    RESULTS_PRODUCTS_FACETS_DRAWER: 'search-results-products-facets-drawer',
    RESULTS_PRODUCTS_SORT_SELECT: 'search-results-products-sort-select',
    RESULTS_PRODUCTS_SELECTED_FILTERS: 'search-results-products-selected-filters',
    RESULTS_SERVICES: 'search-results-services',
    RESULTS_SERVICES_SKELETON: 'search-results-services-skeleton',
    RESULTS_HELP: 'search-results-help',
    RESULTS_HELP_SKELETON: 'search-results-help-skeleton',
    RESULTS_HELP_ITEMS: 'search-results-help-items',
    RESULTS_HELP_FILTERS: 'search-results-help-filters',
    RESULTS_CONTENT: 'search-results-content',
    RESULTS_CONTENT_SKELETON: 'search-results-content-skeleton',
    NO_RESULTS: 'search-no-results',
    NO_RESULTS_SPECIAL_OFFERS: 'search-no-results-special-offers',
    NO_RESULTS_PRODUCTS_SKELETON: 'search-no-results-products-skeleton',
    PAGINATION_COUNT: 'search-pagination-count',
    PAGINATION_PAGES: 'search-pagination-pages',
    PAGINATION_LINK: 'search-pagination-link',
    FACETS_DRAWER_OPEN_BUTTON: 'search-facets-drawer-open-button',
    FACETS_DRAWER_CLOSE_BUTTON: 'search-facets-drawer-close-button',
    FACETS_DRAWER_CLEAR_BUTTON: 'search-facets-drawer-clear-button',
    FACETS_DRAWER_FILTER_BUTTON: 'search-facets-drawer-filter-button',
    FACETS_PRICE_FILTER: 'search-facets-price-filter',
    FACETS_PRICE_FILTER_TYPE_CHANGE: 'search-facets-price-filter-type-change',
    FACETS_ITEM_EXPAND_BUTTON: 'search-facets-item-expand-button',
    FACETS_ITEM: 'search-facets-item',
    COMPARE_ITEM_CHECKBOX: 'compare-item-checkbox',
};
